import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, ActivityIndicator, I18nManager as RNI18nManager,
	Platform, Dimensions, I18nManager, AsyncStorage } from "react-native";
	
import * as firebase from "firebase";
import store from "../config/config.json"
import { color } from "../config/color"
import MainComponent from "../utilities/MainComponent";
import AppContext from "../utilities/AppContext"
import * as moment from 'moment';

export default class ShareScreen extends MainComponent {	

	static path = "share"
	state = {
		itemKey : undefined,
		store: {},
	};
	
	static navigationOptions = {
		headerShown: false
	};

	constructor(props) {
		super(props);

		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		
		this.state.height = screenHeight
		this.state.width = screenWidth
	
		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}
	}

	componentDidMount() {	

		try{
			Dimensions.addEventListener('change', (e) => {
				const { width, height } = e.window;
				this.setState({height: height, width: width})
				if(width < color.screenLimit){
					this.setState({showFullMode: false});			
				}else{
					this.setState({showFullMode: true});			
				}
			})
			
			this.getDetails()
		}catch{}
	}

	getDetails = async () => {		
		
		 // Set the key-value pairs for the different languages you want to support.
		 var that = this
		 firebase.database().ref('stores/' + store.storeId).once("value", function(snapshot) {			
				
			 let data = snapshot.val()
			 if(data != undefined)
			 {
				 that.saveData(data)
			 }
			 else
			 {
				 that.setState({showLoading: false})
			 }
 
		 }.bind(this), function(error) { 
			 console.log(error)
		 });
	}

	saveData = async data => {
		
		let keys = Object.keys(this.props.navigation.state.params)
		if (keys == undefined || keys.length === 0){
			this.props.navigation.navigate("menu")
			return
		}

		this.state.itemCode = keys[0]
		console.log(this.state.itemCode)
		var that = this;
		await AsyncStorage.setItem(store.storeData, JSON.stringify(data))
		firebase.database().ref('data/' + store.storeId).once("value", function(snapshot) {
			if(snapshot.exists())
			{			
				snapshot.forEach(function(childSnapshot) {								
					
					var childData = childSnapshot.val();
					var itemsList = childData.items
					if (itemsList != undefined)
					{
						Object.keys(itemsList).forEach(key => {
							let value = itemsList[key];
							if(value.itemCode == that.state.itemCode)
								that.context.itemData = value																			
						});
						
					}						
				});

				that.setState({showLoading: false})
				if(that.context.itemData == undefined){
					that.props.navigation.navigate('menu')
				}else{
					
					var mUpdates = {
						key: that.context.itemData.key,
						name: that.context.itemData.name,
						price: that.context.itemData.price,
						share: firebase.database.ServerValue.increment(0),
						views    : firebase.database.ServerValue.increment(1)
					}
					
					firebase.database().ref('statistics/stores/sharedItems/' + store.storeId + '/monthly/shift_' + moment(new Date()).format('MMYYYY') + "/" + that.context.itemData.key).update(mUpdates)
					
					that.props.navigation.navigate('details', {
						item: that.context.itemData
					});
				}						
			}
			else
			{
				//that.props.navigation.navigate("menu")
			}	

		}.bind(this), function(error) { 
			console.log(error)
		});
	};
	
	render() {

		return (
			<AppContext.Consumer>
			{ (context) => (
				<View style={{flex: 1, justifyContent: "center", alignItems: "center", alignItems: "center"}} ref={(ref) => { 
					this.context = context; 					
				}}>
						<ActivityIndicator size="small" color={store.primaryColor} /> 
				</View>			
			)}
			</AppContext.Consumer>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: color.bigSeparator
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	},
	topBar: {
		backgroundColor: "white",
        position: "absolute",
        width: "100%", 
        height: 50,
		flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
    }
});